import React from 'react';
import { motion } from 'framer-motion';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import BoltIcon from '@mui/icons-material/Bolt';
import PublicIcon from '@mui/icons-material/Public';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
const BACKGROUND_IMG = 'https://cdn.magicpatterns.com/uploads/1pCG4kjvyotiapaM1aMB52/ChatGPT_Image_19_may_2026,_13_20_08.png';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/a9iZaKaCbWie5VVkRLnQKi/ponele_al_lado_una_table_202605191318.jpg';
export function Hero() {
  return <section className="relative overflow-hidden" data-id="element-119">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${BACKGROUND_IMG})`
    }} aria-hidden="true" data-id="element-120" />
      {/* Overlay to ensure text legibility on top of background */}
      <div className="absolute inset-0 bg-brand-cream/75 md:bg-brand-cream/70" aria-hidden="true" data-id="element-121" />

      <div className="relative pt-3 pb-6 md:pt-6 md:pb-10 px-4 md:px-12 max-w-7xl mx-auto" data-id="element-122">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-123">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-3 md:space-y-5" data-id="element-124">
            <div className="space-y-2 md:space-y-3 text-center md:text-left" data-id="element-125">
              <span className="inline-block text-brand-gold font-bold tracking-widest text-[10px] md:text-sm uppercase border border-brand-gold/30 px-2 py-0.5 md:px-3 md:py-1 rounded-full bg-brand-gold/10 backdrop-blur-sm" data-id="element-126">
                🕯️ VELAS GOURMET™
              </span>
              <h1 className="md:text-5xl lg:text-6xl font-bold text-balance text-[25px]" data-id="element-127">
                Domina el secreto de las{' '}
                <span className="text-brand-gold italic" data-id="element-128">
                  Velas Comestibles Gourmet
                </span>
              </h1>
              <h2 className="md:text-2xl font-serif text-[15px] font-[600] text-[#1E1A18]" data-id="element-129">
                y monta un negocio irresistible desde tu cocina en menos de 7
                días.
              </h2>

              {/* Mobile-only product image */}
              <div className="md:hidden relative pt-2 pb-1" data-id="element-130">
                <div className="absolute inset-0 bg-brand-gold/20 blur-3xl rounded-full" data-id="element-131"></div>
                <img src={PRODUCT_IMG} alt="Libro y tablet Velas Gourmet - Velas que se comen" className="relative z-10 w-56 mx-auto drop-shadow-2xl rounded-lg" style={{
                filter: 'drop-shadow(0 15px 15px rgba(26, 15, 10, 0.4))'
              }} data-id="element-132" />
              </div>

              {/* Mobile-only viral subtitle */}
              <p className="md:hidden px-2 text-[13px] font-[500] text-[#191616]" data-id="element-133">
                El producto más viral y menos competido del año. Sin necesidad
                de experiencia previa, con insumos accesibles y un margen de
                ganancia de más del 200%.
              </p>
            </div>

            <p className="hidden md:block text-lg text-brand-choco-deep/80 leading-relaxed" data-id="element-134">
              El producto más viral y menos competido del año. Sin necesidad de
              experiencia previa, con insumos accesibles y un margen de ganancia
              de más del 200%.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-1 md:gap-3" data-id="element-135">
              {[{
              icon: <PictureAsPdfIcon style={{
                fontSize: 12
              }} data-id="element-136" />,
              text: '100% PDF'
            }, {
              icon: <BoltIcon style={{
                fontSize: 12
              }} data-id="element-137" />,
              text: 'Acceso 5 min'
            }, {
              icon: <PublicIcon style={{
                fontSize: 12
              }} data-id="element-138" />,
              text: 'ARS'
            }, {
              icon: <RestaurantIcon style={{
                fontSize: 12
              }} data-id="element-139" />,
              text: 'Dulces y Saladas'
            }, {
              icon: <MenuBookIcon style={{
                fontSize: 12
              }} data-id="element-140" />,
              text: 'Desde cero'
            }].map((badge, i) => <span key={i} className="flex items-center gap-0.5 bg-brand-ivory/90 backdrop-blur-sm border border-brand-choco/10 text-brand-choco-deep px-1.5 py-0.5 md:px-3 md:py-1.5 rounded text-[9px] md:text-sm font-medium shadow-sm" data-id="element-141">
                  <span className="text-brand-gold" data-id="element-142">{badge.icon}</span>
                  {badge.text}
                </span>)}
            </div>

            <div className="space-y-2 md:space-y-3" data-id="element-143">
              <a href="#pricing" className="block w-full text-center bg-brand-gold hover:bg-brand-amber text-brand-choco-deep font-bold py-3 md:py-4 px-4 md:px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-sm md:text-lg" data-id="element-144">
                🕯️ QUIERO LAS VELAS QUE SE COMEN AHORA
              </a>

              <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-[11px] md:text-sm text-brand-choco/70 font-medium" data-id="element-145">
                <span className="flex items-center gap-1" data-id="element-146">
                  <ShieldIcon style={{
                  fontSize: 14
                }} className="text-brand-gold" data-id="element-147" />
                  Garantía 7 días
                </span>
                <span className="flex items-center gap-1" data-id="element-148">
                  <LockIcon style={{
                  fontSize: 14
                }} className="text-brand-gold" data-id="element-149" />
                  Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-150">
                  <CreditCardIcon style={{
                  fontSize: 14
                }} className="text-brand-gold" data-id="element-151" />
                  Mercado Pago
                </span>
              </div>
            </div>
          </motion.div>

          {/* Desktop-only right column image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: -2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative perspective-1000 hidden md:block" data-id="element-152">
            <div className="absolute inset-0 bg-brand-gold/20 blur-3xl rounded-full transform -translate-y-10" data-id="element-153"></div>
            <img src={PRODUCT_IMG} alt="Libro y tablet Velas Gourmet - Velas que se comen" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-2xl rounded-xl transform hover:scale-105 transition-transform duration-500" style={{
            filter: 'drop-shadow(0 25px 25px rgba(26, 15, 10, 0.4))'
          }} data-id="element-154" />
          </motion.div>
        </div>
      </div>
    </section>;
}